import { render } from "./Recall.vue?vue&type=template&id=20b3fcb8&scoped=true"
import script from "./Recall.vue?vue&type=script&lang=js"
export * from "./Recall.vue?vue&type=script&lang=js"

import "./Recall.vue?vue&type=style&index=0&id=20b3fcb8&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/lemmi_front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20b3fcb8"]])

export default __exports__